/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ReactPlayer from 'react-player';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';
import { apiUrl2, bannerImgUrl, goodsImgUrl } from '../../common/urls';
import OnAirItem from '../../components/OnAirItem';

const Chuhon = () => {
  const [list, setList] = useState([]);

  const getData = async () => {
    const result = await axios.get(apiUrl2 + '/onChuchon');
    const intReturn = result.data[0].intReturn;
    if (intReturn === 0) {
      setList(result.data[0].listData);
    }
  };
  const _goLaftel = (url) => {
    window.open(url);
  };
  useEffect(() => {
    getData();
  }, []);
  console.log(list);
  return (
    <>
      {list.length > 0 && (
        <div className="container_c">
          <h1>
            <strong>이건 꼭 봐야해! 추천 TV 시리즈</strong>
          </h1>
          <div
            className="main_list_style"
            style={{
              backgroundImage: `url(${list[0].thumbImg})`,
              //   backgroundColor: 'cover',
              //   filter: `blur(8px)`,
              //   width: '100%',
              //   height: '100%',
              //   zIndex: -1,
            }}
          >
            <div className="main_list_goup4">
              <dl>
                <dt>
                  <div>
                    <img src={list[0].thumbImg} className="img_logo" />
                  </div>
                </dt>

                <dd>
                  <div className="text_group">
                    {list[0].imageLO === '' ? (
                      <h2>{list[0].title}</h2>
                    ) : (
                      <img src={list[0].imageLO} className="img_logo" />
                    )}

                    <h2>
                      <span>{list[0].genreName}</span>
                      <span> | </span>
                      <span>{list[0].restrictionCode} 이상</span>
                    </h2>
                    <div>
                      <h2>{list[0].comment}</h2>
                    </div>
                    {list[0].contentSysnopsis === '' ||
                    list[0].contentSysnopsis === undefined ||
                    list[0].contentSysnopsis == null ? null : (
                      <HTMLEllipsis
                        unsafeHTML={`<p>${list[0].contentSysnopsis.replace(
                          /<[^>]+>/g,
                          ''
                        )}</p>`}
                        maxLine="3"
                        ellipsis="..."
                        basedOn="letters"
                      />
                    )}
                    {list[0].laftel && (
                      <a
                        style={{ cursor: 'pointer' }}
                        onClick={() => _goLaftel(list[0].laftel)}
                      >
                        {/* <img src={'/img/play4.png'} /> */}
                        라프텔에서 감상하기
                      </a>
                    )}
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default shopContext(withRouter(Chuhon));
